import { Component, Input, OnInit, Output, EventEmitter, inject, ViewContainerRef, signal } from '@angular/core';
import { CommonModule } from "@angular/common";
import { CurrencyClpPipe } from "../pipes/currency-clp.pipe";
import { ModalComponent } from "../ui/modal/modal.component";
import { Charge } from "../models/charge.models";
import { BadgeComponent } from '../ui/badge/badge.component';
import { DocTypeLabelPipe } from '../pipes/doc-type.pipe';
import { getBadgeVariant } from '../../../services/graphQl/charge/charge.service';
import html2pdf from 'html2pdf.js';
import { VoucherTemplateComponent } from '../voucher-html/voucher-template.component';

@Component({
  selector: 'app-charge-detail-dialog',
  standalone: true,
  imports: [CommonModule, CurrencyClpPipe, DocTypeLabelPipe, ModalComponent, BadgeComponent],
  templateUrl: './charge-detail-dialog.component.html',
  styleUrl: './charge-detail-dialog.component.css'
})
export class ChargeDetailDialogComponent implements OnInit {
  private viewContainerRef = inject(ViewContainerRef);

  generatingPdf = signal(false);

  @Input({ required: true }) charge!: Charge;

  @Output() close = new EventEmitter<void>();

  constructor(
  ) {}

  ngOnInit(): void {

  }

  getVariant(charge: Charge) {
    return getBadgeVariant(charge);
  }

  async generatePDF() {
    this.generatingPdf.set(true);

    // Espera un micro-tick para que Angular renderice el loader (si no se agrega, espera a que la funcion termine y ya es tarde)
    await new Promise(resolve => setTimeout(resolve));

    // Crear dinámicamente el componente del template
    const compRef = this.viewContainerRef.createComponent(VoucherTemplateComponent);

    // Asignar inputs al template
    compRef.setInput('charge', this.charge);

    // Obtener el elemento HTML del componente
    const element = compRef.location.nativeElement;
    const container = document.getElementById('pdf-container');
    if (!container) {
      console.error('No se encontró el contenedor #pdf-container');
      return;
    }
    container.appendChild(element);

    const created_at = this.charge.date || new Date();
    const created_at_short = this.formatDateToShort(created_at);
    const filename = `comprobante_cobro_${this.charge.order_number}_${created_at_short}.pdf`;
    const opt = {
      margin: [10, 10, -10, 10],
      filename,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 2,
        scrollY: 0,
        windowWidth: 800,
        backgroundColor: '#ffffff',
        useCORS: true
      },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      pagebreak: { mode: ['css', 'legacy'] }
    };

    try {
      await html2pdf().set(opt).from(element).save();
    } catch (err) {
      console.error('Error generando PDF:', err);
    } finally {
      container.removeChild(element);
      compRef.destroy();
      this.generatingPdf.set(false);
    }
  }

  private formatDateToShort(dateInput: any): string {
    let date: Date;

    if (typeof dateInput === 'string') {
      date = new Date(dateInput.replace(' ', 'T'));
    } else if (dateInput instanceof Date) {
      date = dateInput;
    } else {
      return '';
    }

    if (isNaN(date.getTime())) return '';

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }
}
